import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import { mapServerToSunglassesSpecifications } from '../specification-mappers/map-server-to-sunglasses-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';
import { getLensProductFeatures } from '../utils/get-lens-product-features.js';
import { getFrameMeasurements } from '../utils/get-frame-measurements.js';

const mapServerToSunglassesVariant = (serverProduct, slug, locale)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale);
        if (!variantBase) return;
        const { variantTypeDetails  } = serverVariant;
        const { frameFeatures , lensFeatures  } = variantTypeDetails;
        const { bridgeWidth , color: frameColor , width: frameWidth , size: frameSize , templeLength ,  } = frameFeatures !== null && frameFeatures !== void 0 ? frameFeatures : {};
        const { lensColor , lensHeight , lensWidth  } = lensFeatures !== null && lensFeatures !== void 0 ? lensFeatures : {};
        const { brand  } = serverProduct;
        const frameColorName = Array.isArray(frameColor) ? frameColor.join(' / ') : frameColor;
        const colorFacet = [
            lensColor,
            frameColorName
        ].filter(Boolean).join(' / ');
        const specifications = mapServerToSunglassesSpecifications(serverVariant, brand, !!serverProduct.productTypeDetails.isOfferedWithPrescriptions);
        const productFeatures = lensFeatures ? getLensProductFeatures(lensFeatures) : [];
        const frameMeasurements = getFrameMeasurements(bridgeWidth, frameWidth, lensHeight, lensWidth, templeLength);
        var ref;
        return swcHelpers.objectSpread({}, variantBase, {
            facets: {
                color: !!colorFacet ? colorFacet : undefined,
                size: (ref = frameSize === null || frameSize === void 0 ? void 0 : frameSize.size) !== null && ref !== void 0 ? ref : undefined
            },
            channelAvailability: variantTypeDetails.channelAvailability,
            specifications,
            isVtoEnabled: !!variantTypeDetails.isVtoEnabled,
            isReservable: variantTypeDetails.isReservable,
            productFeatures,
            frameMeasurements
        });
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToSunglassesVariant };
//# sourceMappingURL=map-server-to-sunglasses-variant.js.map
